<template>
    <div>
        <div v-bind:class="ifLoading" class="loader">
            <TheSpinner />
        </div>
        <div v-if="loading">
            <div class="content">
                <formular_anmeldung v-if="items[1].template == 1"/>
            </div>
        </div>
    </div>
</template>

<script>

    import formular_anmeldung from '../formular/formular_anmeldung'
    import TheSpinner from "../TheSpinner"

    export default {
        name: 'TheButtonLink',
        components: {
            formular_anmeldung,
            TheSpinner
        },
        data(){
            return{
                loading: false,
                items: [],
            }
        },
        created: function(){
            const baseURI = 'https://api.pgsi2020.de/api/file/formular.json'
            this.$http.get(baseURI)
                .then((result) => {
                    this.items = result.data,
                        this.loading = true
                })
        },
        watch: {
            '$route.params.id': function (id) {
                this.loading = false;
                const baseURI = 'https://api.pgsi2020.de/api/file/formular.json'
                this.$http.get(baseURI)
                    .then((result) => {
                        this.items = result.data,
                            this.loading = true
                    })

            }
        },
        computed: {
            ifLoading() {
                if(this.loading){
                    return 'loaded';
                }else{
                    return 'isLoading';
                }
            }
        }




    }
</script>

<style>
    .content{
        max-width: 900px;
        margin: 0 auto;
        padding: 30px;
    }
</style>
